export const GET_LIST_HOPDONGDELETE = "GET_LIST_HOPDONGDELETE";
export const GET_LIST_HOPDONGDELETE_SUCCESS = "GET_LIST_HOPDONGDELETE_SUCCESS";
export const GET_LIST_HOPDONGDELETE_FAILURE = "GET_LIST_HOPDONGDELETE_FAILURE";

export const UPDATE_SEARCHTDATA_HOPDONGDELETE =
  "UPDATE_SEARCHTDATA_HOPDONGDELETE";
